function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return String(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
}

/**
 * Strips Devanagari (Hindi) characters from an address string and trims
 * any leftover punctuation / whitespace from the result.
 *
 * Covers:
 * - Parentheses enclosing Hindi phrases like (कमिश्नरेट आगरा)
 * - Devanagari Unicode block (U+0900 – U+097F)
 * - Devanagari Extended (U+A8E0 – U+A8FF)
 * - Vedic Extensions (U+1CD0 – U+1CFF)
 */
function stripHindi(text) {
    if (!text || typeof text !== 'string') return '';
    const clean = text
        // Remove parenthesized segments containing Hindi e.g. (कमिश्नरेट आगरा)
        .replace(/\([^a-zA-Z0-9]*[\u0900-\u097F\uA8E0-\uA8FF]+[^a-zA-Z0-9]*\)/g, '')
        // Remove all Devanagari, Vedic and Extended Devanagari characters
        .replace(/[\u0900-\u097F\uA8E0-\uA8FF\u1CD0-\u1CFF]+/g, '')
        // Remove empty or whitespace-only parentheses left behind
        .replace(/\(\s*\)/g, '')
        // Normalize multiple spaces/tabs
        .replace(/[ \t]+/g, ' ')
        // Clean up punctuation spacing and consecutive commas
        .replace(/\s*,\s*/g, ', ')
        .replace(/(,\s*)+/g, ', ')
        // Trim leading/trailing commas, dashes, dots, spaces
        .replace(/^[,\s.-]+|[,\s.-]+$/g, '')
        .trim();

    return clean || text;
}

module.exports = {
    formatDate,
    stripHindi,
};
